import React, { useEffect } from 'react';
import { AnnouncementBar } from './components/AnnouncementBar';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { SocialProofBar } from './components/SocialProofBar';
import { ProblemSection } from './components/ProblemSection';
import { ProductBundle } from './components/ProductBundle';
import { BonusesSection } from './components/BonusesSection';
import { UpgradesSection } from './components/UpgradesSection';
import { HowItWorks } from './components/HowItWorks';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { initMetaPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full min-h-screen bg-[#060B18] font-body" data-id="element-0">
      <AnnouncementBar data-id="element-1" />
      <Navbar data-id="element-2" />
      <HeroSection data-id="element-3" />
      <SocialProofBar data-id="element-4" />
      <ProblemSection data-id="element-5" />
      <ProductBundle data-id="element-6" />
      <BonusesSection data-id="element-7" />
      <UpgradesSection data-id="element-8" />
      <HowItWorks data-id="element-9" />
      <TestimonialsSection data-id="element-10" />
      <GuaranteeSection data-id="element-11" />
      <FAQSection data-id="element-12" />
      <FinalCTA data-id="element-13" />
      <Footer data-id="element-14" />
    </div>;
}